import {makeAutoObservable, runInAction} from 'mobx';
import {fetchRating, fetchRatingTabs} from "@/shared/api/api";
import {RootStore} from "@/app/providers/StoreProvider";
import {IRatingList, IRatingTabs} from "@/entities/rating/types";

export class RatingStore {

    constructor(private rootStore: RootStore) {
        makeAutoObservable(this);
    }

    private get errorStore() {
        return this.rootStore.errorStore;
    }

    loading: boolean = false;

    ratingTabs: IRatingTabs[] = [];
    rating:IRatingList[] = [];

    currentTab: string = 'TEAM_GLOBAL';


    getRatingTabs = async () => {
        this.loading = true;
        try {
            const ratingTabs = await fetchRatingTabs();
            if (ratingTabs.success) {
                runInAction(() => {
                    this.ratingTabs = ratingTabs.data;
                    this.currentTab = ratingTabs.data[0].ratingId;
                });
            } else {
                this.errorStore.setError(ratingTabs.error)
            }
        } finally {
            runInAction(() => {
                this.loading = false;
            });
        }

    }


    getRating = async (id:string) => {
        this.loading = true;
        try {
            const rating = await fetchRating(id);
            if (rating.success) {
                runInAction(() => {
                    this.rating = rating.data;
                });
            } else {
                this.errorStore.setError(rating.error)
            }
        } finally {
            runInAction(() => {
                this.loading = false;
            });
        }

    }

    changeTab = async (id:string) => {
        this.rating = [];
        this.currentTab = id;
    }

    resetRating = async () => {
        this.rating = [];
        this.currentTab = 'TEAM_GLOBAL';
    }


}
